import { isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled } from '@white-label-plugin/launch-darkly';

const LOUNGE_PASS_PROVIDER = 'lounge-pass';

type LoungeProviderDetails = {
  inventory_provider?: string | null;
};

type LoungePassProduct = {
  inventory_provider?: string | null;
  order_criteria?: {
    lounges?: LoungeProviderDetails | null;
  } | null;
  search_criteria?: {
    lounges?: LoungeProviderDetails | null;
  } | null;
} | null | undefined;

export function isLoungePass(product: LoungePassProduct): boolean {
  if (!product) {
    return false;
  }

  return (
    isGtm1216PriorityPassLoungesCollinsonIntegrationEnabled()
    && (
      product.inventory_provider === LOUNGE_PASS_PROVIDER
      || product.order_criteria?.lounges?.inventory_provider === LOUNGE_PASS_PROVIDER
      || product.search_criteria?.lounges?.inventory_provider === LOUNGE_PASS_PROVIDER
    )
  );
}
